/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ComponentPropsWithoutRef, useState } from "react";
import { type AnyObject as yupAnyObject } from "yup/lib/types";
import PillarForm from "shared/components/pillar-form/PillarForm";
import PillarModalBody from "shared/components/pillar-modal/NewPillarModalBody";

// export type ConfirmationModalRefProps = ;
export type ConfirmationModalProps = Omit<
  ComponentPropsWithoutRef<typeof PillarModalBody<true>>,
  "children"
> & {
  approveAction?: (...args: any[]) => any;
  actionName?: string;
  title?: string;
  subtitle?: string;
  testid?: string;
  approveActionClassName?: string;
  children?: React.ReactNode;
  wrapperClassName?: string;
  formYupValidation?: yupAnyObject;
  formOverrideInitialValues?: Record<string, unknown>;
  formValidateOnChange?: boolean;
};

export const ConfirmationModal = <T,>({
  approveAction,
  actionName,
  testid,
  title,
  subtitle,
  children,
  approveActionClassName = "button-regular-general-filled",
  formYupValidation,
  formOverrideInitialValues,
  formValidateOnChange,
  control,
  ...props
}: ConfirmationModalProps) => {
  const [errorMessage, setErrorMessage] = useState("");
  return (
    <PillarModalBody
      testid={`${testid}-confirmation-modal`}
      title={title}
      className="overflow-y-hidden"
      control={control}
      {...props}
    >
      <div className={props.wrapperClassName ?? "py-4"}>
        <PillarForm
          yupValidation={formYupValidation}
          overrideInitialValues={formOverrideInitialValues}
          validateOnChange={formValidateOnChange}
          handleSubmit={async (values, formikHelpers) => {
            const response = await approveAction?.(values);
            if (
              response &&
              typeof response === "object" &&
              "isSuccessful" in response &&
              !response.isSuccessful
            ) {
              setErrorMessage(response.error);
              return;
            }
            control.setIsOpen(false);
          }}
        >
          {!children && (
            <div className="flex justify-center pb-2">
              <h6>{subtitle}</h6>
            </div>
          )}
          {errorMessage && (
            <div className="text-center text-status-danger-tint pb-2">
              {errorMessage}
            </div>
          )}
          {children}
          <div className="flex justify-center gap-1 px-2">
            <PillarForm.Button
              onClick={() => control.setIsOpen(false)}
              className={`button-regular-neutral-filled ${
                approveAction && "w-full"
              }`}
              testid={`${testid}-confirmation-modal-cancel`}
            >
              No, Cancel
            </PillarForm.Button>
            {approveAction && (
              <PillarForm.LoadingSubmitButton
                className={"button-regular-destructive-filled w-full"}
                testid={`${testid}-confirmation-modal-approve`}
                label={`Yes, ${actionName}`}
              />
            )}
          </div>
        </PillarForm>
      </div>
    </PillarModalBody>
  );
};
